import { __assign, __extends } from "tslib";
import React from 'react';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { UPDATE_MESSAGE_CENTER, UPDATE_LOAN_PREF, CHANGE_LANGUAGE } from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { PnmacCard, PnmacPaper, PnmacParagraph, PnmacRowHeader, PnmacRadioButton, PnmacMediaQuery, PnmacUIButton, PnmacMeta } from 'pnmac-universal-components';
import styles from '../../styles/styles.js';
import { SuccessMessage } from '../../components/SuccessMessage.js';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import BannerView from "../../v2/BannerView";
import { textStyle } from "../../v2/theme";
var LanguagePreferences = /** @class */function (_super) {
  __extends(LanguagePreferences, _super);
  function LanguagePreferences(props) {
    var _this = this;
    var _a, _b;
    _this = _super.call(this, props) || this;
    _this.updateMessageCenter = function (value, property) {
      var customerPreference = _this.state.customerPreference;
      if (property == 300097) {
        _this.props.dispatch({
          type: CHANGE_LANGUAGE,
          lang: value == 300100 ? 'es' : 'en',
          sendNotification: false
        });
      }
      var index = customerPreference === null || customerPreference === void 0 ? void 0 : customerPreference.findIndex(function (s) {
        return parseInt(s.prefenceTypeId) == parseInt(property);
      });
      if (index > -1) {
        if (customerPreference[index].BorrowerId === undefined || customerPreference[index].BorrowerId === 0) {
          customerPreference[index].BorrowerId = _this.props.layout.borrowerId;
        }
        customerPreference[index].changed = true;
        customerPreference[index].prefenceValueTypeId = value;
      } else {
        var l = __assign({}, customerPreference[0]);
        l.prefenceValueTypeId = value;
        l.prefenceTypeId = property;
        l.changed = true;
        l.BorrowerId = _this.props.layout.borrowerId;
        customerPreference.push(l);
      }
      _this.setState({
        customerPreference: customerPreference,
        customerPreferenceUpdate: true,
        notchanged: false
      }, function () {
        _this.props.dispatch({
          type: UPDATE_MESSAGE_CENTER,
          customerPreference: customerPreference
        });
      });
    };
    _this.changeValue = function (value, property) {
      var loanPreference = _this.state.loanPreference;
      var index = loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.findIndex(function (s) {
        return parseInt(s.preferenceTypeCode) == parseInt(property);
      });
      if (index > -1) {
        loanPreference[index].changed = true;
        loanPreference[index].preferenceCode = value;
      } else {
        var l = __assign({}, loanPreference[0]);
        l.preferenceTypeCode = property;
        l.preferenceCode = value;
        l.changed = true;
        loanPreference.push(l);
      }
      _this.setState({
        loanPreference: loanPreference,
        loanPrferencesUpdate: true,
        notchanged: false
      }, function () {
        return _this.props.dispatch({
          type: UPDATE_LOAN_PREF,
          selectedLoanPreference: loanPreference
        });
      });
    };
    _this.status = function (check, type) {
      return type == check ? "checked" : "unchecked";
    };
    _this.state = {
      customerPreference: (_a = props.layout) === null || _a === void 0 ? void 0 : _a.customerPreference,
      loanPreference: (_b = props.layout) === null || _b === void 0 ? void 0 : _b.selectedLoanPreference,
      customerPreferenceUpdate: false,
      loanPrferencesUpdate: false,
      confirmFinal: false,
      loading: false,
      notchanged: true
    };
    return _this;
  }
  LanguagePreferences.getDerivedStateFromProps = function (props, state) {
    var _a, _b, _c, _d;
    if (!state.loanPreference || ((_a = state.loanPreference) === null || _a === void 0 ? void 0 : _a.length) == 0 || state.loanPreference != props.layout.selectedLoanPreference) {
      return __assign(__assign({}, state), {
        loanPreference: (_b = props.layout) === null || _b === void 0 ? void 0 : _b.selectedLoanPreference
      });
    } else if (!state.customerPreference || ((_c = state.customerPreference) === null || _c === void 0 ? void 0 : _c.length) == 0) {
      return __assign(__assign({}, state), {
        customerPreference: (_d = props.layout) === null || _d === void 0 ? void 0 : _d.customerPreference
      });
    } else {
      return null;
    }
  };
  LanguagePreferences.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      layout = _a.layout,
      translations = _a.translations;
    var _b = this.state,
      customerPreference = _b.customerPreference,
      loanPreference = _b.loanPreference,
      notchanged = _b.notchanged,
      confirmFinal = _b.confirmFinal,
      loading = _b.loading;
    var selectedLoanNumber = layout.selectedLoanNumber;
    var correspondence = (loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.find(function (s) {
      return s.preferenceTypeCode == 300098;
    })) || {};
    var communications = (customerPreference === null || customerPreference === void 0 ? void 0 : customerPreference.find(function (s) {
      return s.prefenceTypeId == 300097;
    })) || {};
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: "Language Preferences"
      }), /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, " ", /*#__PURE__*/React.createElement("b", null, translations.Note, ":"), " ", translations.LanguagePreferencesForLoan, " ", (_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.loanId)), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%"
        }
      }, confirmFinal ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            confirmFinal: false
          });
        },
        message: translations.LanguagePreferenceSuccessMessage
      }) : null, /*#__PURE__*/React.createElement(PnmacRowHeader, {
        rowHeaderContainerStyles: styles.accountSettings.titleContainer,
        item: translations.LanguagePreferences
      }), /*#__PURE__*/React.createElement(PnmacPaper, {
        containerStyles: {
          padding: 25,
          marginBottom: 20,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          backgroundColor: "#FFF",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
          elevation: 1,
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, translations === null || translations === void 0 ? void 0 : translations.LanguageSubTitle)), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "nowrap",
          width: "100%",
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "85%"
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, translations === null || translations === void 0 ? void 0 : translations.LanguageStatementAndDocuments), /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, translations === null || translations === void 0 ? void 0 : translations.LanguageStatementAndDocumentsDescription)), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: matches.small ? 25 : 50,
          display: "flex",
          flexDirection: "row",
          paddingBottom: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginRight: 15
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.Spanish), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: "rdbCorrespondenceSpanish",
        status: _this.status(correspondence === null || correspondence === void 0 ? void 0 : correspondence.preferenceCode, 300100),
        onPress: function () {
          return _this.changeValue(300100, 300098);
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.English), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: "rdbCorrespondenceEnglish",
        status: Object.keys(correspondence).length == 0 ? "checked" : _this.status(correspondence === null || correspondence === void 0 ? void 0 : correspondence.preferenceCode, 300099),
        onPress: function () {
          return _this.changeValue(300099, 300098);
        }
      })))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "nowrap",
          width: "100%",
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "85%"
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, translations === null || translations === void 0 ? void 0 : translations.LanguageElectronicCommunicationsConsent), /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, translations === null || translations === void 0 ? void 0 : translations.LanguageElectronicCommunicationsConsentDesc1), /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, translations === null || translations === void 0 ? void 0 : translations.LanguageElectronicCommunicationsConsentDesc2)), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: matches.small ? 25 : 50,
          display: "flex",
          flexDirection: "row",
          paddingBottom: 20
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginRight: 15
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.Spanish), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: 'rdbElecCommunicationsSpanish',
        status: _this.status(communications === null || communications === void 0 ? void 0 : communications.prefenceValueTypeId, 300100),
        onPress: function () {
          return _this.updateMessageCenter(300100, 300097);
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.English), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: 'rdbElecCommunicationsEnglish',
        status: Object.keys(communications).length == 0 ? "checked" : _this.status(communications === null || communications === void 0 ? void 0 : communications.prefenceValueTypeId, 300099),
        onPress: function () {
          return _this.updateMessageCenter(300099, 300097);
        }
      }))))), /*#__PURE__*/React.createElement("div", {
        style: styles.accountSettings.buttonContainer
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        idTag1: 'btnLanguagePreferenceChange',
        loading: _this.state.loading,
        disabled: notchanged,
        onPress: function () {
          _this.setState({
            loading: true
          });
          if (_this.state.loanPrferencesUpdate && parseInt(selectedLoanNumber) > 0) {
            var loanPrefs = loanPreference.filter(function (s) {
              return parseFloat(s.loanId) === parseFloat(selectedLoanNumber) && s.preferenceTypeCode === 300098;
            });
            fetch("/api/loan/update_loan_preferences", {
              method: 'POST',
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "Bearer ".concat(_this.props.layout.token)
              },
              body: JSON.stringify(loanPrefs)
            }).then(function (res) {
              return res.json();
            }).then(function (data) {
              if (data) {
                _this.setState({
                  loading: false,
                  confirmFinal: true,
                  notchanged: true
                });
              }
            });
          }
          if (_this.state.customerPreferenceUpdate && parseInt(_this.props.layout.selectedLoanNumber) > 0) {
            customerPreference.forEach(function (s) {
              return s.loanId = _this.props.layout.selectedLoanNumber;
            });
            fetch("/api/account/update_customer_preferences?sendNotification=false", {
              method: 'POST',
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "Bearer ".concat(_this.props.layout.token)
              },
              body: JSON.stringify(customerPreference)
            }).then(function (res) {
              return res.json();
            }).then(function (data) {
              var _a;
              if (data) {
                var lang = ((_a = customerPreference === null || customerPreference === void 0 ? void 0 : customerPreference.find(function (s) {
                  return s.prefenceTypeId == 300097;
                })) === null || _a === void 0 ? void 0 : _a.prefenceValueTypeId) == 300100 ? "es" : "en";
                _this.props.layout.changeLanguageFunction(lang);
                _this.setState({
                  loading: false,
                  confirmFinal: true,
                  notchanged: true
                });
              }
            });
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Language Preferences Change Button Clicked", 0);
          }
        },
        style: styles.accountSettings.button
      }, translations.Change)))));
    });
  };
  return LanguagePreferences;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(LanguagePreferences);